// extracted by mini-css-extract-plugin
export default {"overfullCount":"PodCapacity_overfullCount__12bZS"};